/* @flow */
import React from 'react';
import { ReferenceLine as RechartsReferenceLine } from 'recharts';
import { dashboardColors } from 'common/enums/ColorEnum';

import { type RefLineType } from './CartesianChartDataType';

const IfOverflowEnum = {
    Hidden: 'hidden',
    Visible: 'visible',
    Discard: 'discard',
    ExtendDomain: 'extendDomain'
};

type Options = {
    refLines: ?Array<RefLineType>
};

export const renderReferenceLines = ({ refLines }: Options) => {
    return (refLines || []).map<RechartsReferenceLine>((refLine, index) => {
        return (
            <RechartsReferenceLine
                key={index}
                y={refLine.value}
                ifOverflow={
                    refLine.alwaysShow ? IfOverflowEnum.ExtendDomain : null
                }
                label={refLine.label}
                stroke={dashboardColors.salmon.code}
                strokeDasharray="3 3"
            />
        );
    });
};
